const getters = {
    gLanguage: state => state.app.language,
    gSize: state => state.app.size,
    gDevice: state => state.app.device,
    gMainnav: state => state.app.mainnav,
    gRouters: state => state.permission.routers,
    gTourActive: state => state.app.tourActive
  };
  
  export default getters;